<template>
  <v-list-group
    value="publisher"
  >
    <template #activator="{ props }">
      <v-list-item
        min-height="35px"
        v-bind="props"
        :title="t('smpw.publisher', 2)"
      >
        <template #prepend>
          <v-icon

            icon="fas fa-users"
            size="x-small"
          />
        </template>
      </v-list-item>
    </template>
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('help.getting_started')"
      @click="setRailModeOff"
    />
    <menu-item
      :title="t('global.welcome')"
      to="/docs/publisher"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/publisher/starting/my-details"
      :title="t('global.my_details')"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('shift.before_shift')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('access_news_page')"
      to="/docs/publisher/before-shifts/news"
      :title="t('news.title')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="canAny(['handle_tasks', 'manage_tasks'])"
      to="/docs/publisher/before-shifts/my-tasks"
      :title="t('task.mine')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('access_cart_page')"
      to="/docs/publisher/before-shifts/current-carts"
      :title="t('cart.current')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="getSetting('day_overseer_display_type') !== 'location' && can('access_dayoverseers_page')"
      :title="t('dayoverseer.title', 2)"
      to="/docs/publisher/before-shifts/day-overseers"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="getSetting('day_overseer_display_type') === 'location' && can('access_dayoverseers_page')"
      :title="t('dayoverseer.location_overseer', 2)"
      to="/docs/publisher/before-shifts/location-overseers"
      @click="setRailModeOff"
    />
    <v-list-subheader
      color="white"
      class="text-body-large bg-primary-darken-1 opacity-60"
      :title="t('shift.managing')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('submit_availability')"
      to="/docs/publisher/managing-shifts/availability"
      :title="t('smpw.submit_availability')"
      @click="setRailModeOff"
    />
    <menu-item
      :title="t('shift.mine')"
      to="/docs/publisher/managing-shifts/my-shifts"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/publisher/managing-shifts/calendar"
      :title="t('calendar.mine')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/publisher/managing-shifts/current-needs"
      :title="t('shift.current_needs')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('access_locations_page')"
      to="/docs/publisher/managing-shifts/locations"
      :title="t('location.title', 2)"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('shift.after_shift')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('access_experiences_page')"
      to="/docs/publisher/after-shifts/experiences"
      :title="t('experience.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/publisher/after-shifts/contact-us"
      :title="t('actions.contact_us')"
      @click="setRailModeOff"
    />
  </v-list-group>
  <v-list-group
    v-if="authUser.is_admin"
    value="admin"
  >
    <template #activator="{ props }">
      <v-list-item
        min-height="35px"
        v-bind="props"
        :title="t('global.administration')"
      >
        <template #prepend>
          <v-icon

            icon="fas fa-clipboard-user"
            size="x-small"
          />
        </template>
      </v-list-item>
    </template>
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('help.getting_started')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/admin"
      :title="t('global.welcome')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/admin/initial-setup"
      :title="t('global.initial_setup')"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('admin_menu.ministry_management')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="canAny(['manage_shifts', 'view_all_shifts'])"
      to="/docs/admin/ministry-management/schedule"
      :title="t('admin_menu.schedule')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/admin/ministry-management/currentneeds"
      :title="t('shift.current_needs')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_experiences')"
      to="/docs/admin/ministry-management/experiences"
      :title="t('experience.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_dayoverseers') && getSetting('day_overseer_display_type') !== 'location'"
      :title="t('dayoverseer.title', 2)"
      to="/docs/admin/ministry-management/day-overseers"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_dayoverseers') && getSetting('day_overseer_display_type') === 'location'"
      :title="t('dayoverseer.location_overseer', 2)"
      to="/docs/admin/ministry-management/day-overseers"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_shift_plans')"
      to="/docs/admin/ministry-management/shift-plan"
      :title="t('shift_plan.title')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_shift_tags')"
      to="/docs/admin/ministry-management/shift-tags"
      :title="t('shift_tag.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_locations')"
      to="/docs/admin/ministry-management/locations"
      :title="t('location.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_stores')"
      to="/docs/admin/ministry-management/stores"
      :title="t('store.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_publications')"
      to="/docs/admin/ministry-management/publications"
      :title="t('publication.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_cart')"
      to="/docs/admin/ministry-management/carts"
      :title="t('cart.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_time_bands')"
      to="/docs/admin/ministry-management/timebands"
      :title="t('shift.time_band', 2)"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('user.publisher_management')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="canAny(['manage_users', 'view_user_details', 'manage_circuit_users'])"
      to="/docs/admin/publisher-management/publishers"
      :title="t('smpw.publisher', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="canAny(['manage_congregations', 'manage_circuit_congregations'])"
      to="/docs/admin/publisher-management/congregations"
      :title="t('congregation.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_circuits')"
      to="/docs/admin/publisher-management/circuits"
      :title="t('circuit.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="canAny(['manage_teams'])"
      to="/docs/admin/publisher-management/teams"
      :title="t('team.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="canAny(['manage_courses', 'manage_course_sessions'])"
      to="/docs/admin/publisher-management/training"
      :title="t('course.training')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('import_users')"
      to="/docs/admin/publisher-management/bulk-import"
      :title="t('user_import.bulk_import')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_user_rating_labels')"
      to="/docs/admin/publisher-management/rating-labels"
      :title="t('user_rating_label.short')"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('admin_menu.site_management')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="canAny(['manage_reports', 'access_reports'])"
      to="/docs/admin/site-management/reports"
      :title="t('report.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_news')"
      to="/docs/admin/site-management/news"
      :title="t('news.title')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_alert_messages')"
      to="/docs/admin/site-management/alerts"
      :title="t('alert.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_faqs')"
      to="/docs/admin/site-management/faqs"
      :title="t('faq.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_videos')"
      to="/docs/admin/site-management/videos"
      :title="t('video.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_documents')"
      to="/docs/admin/site-management/documents"
      :title="t('document.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_task_categories')"
      to="/docs/admin/site-management/taskcategories"
      :title="t('task.category.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_contact_message_options')"
      to="/docs/admin/site-management/contact-options"
      :title="t('contact_option.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_shift_cancellation_reasons')"
      to="/docs/admin/site-management/cancellation-reasons"
      :title="t('cancellation_reason.title', 2)"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('setting.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_settings')"
      to="/docs/admin/settings/settings"
      :title="t('setting.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="canAny(['manage_roles', 'assign_roles', 'assign_any_role'])"
      to="/docs/admin/settings/roles"
      :title="t('role.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('manage_languages')"
      to="/docs/admin/settings/languages"
      :title="t('language.title', 2)"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('maintenance.title')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('update_application')"
      to="/docs/maintenance/updating"
      :title="t('updates.title', 2)"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('access_system_monitor')"
      to="/docs/admin/maintenance/system-info"
      :title="t('maintenance.system_info')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('access_system_monitor')"
      to="/docs/admin/maintenance/system-monitor-dashboard"
      :title="t('maintenance.system_monitor_dashboard')"
      @click="setRailModeOff"
    />
  </v-list-group>

  <v-list-group
    v-if="authUser.is_admin"
    value="maintenance"
  >
    <template #activator="{ props }">
      <v-list-item
        v-bind="props"
        min-height="35px"
        :title="t('maintenance.title')"
        @click="setRailModeOff"
      >
        <template #prepend>
          <v-icon

            icon="fas fa-cog"
            size="x-small"
          />
        </template>
      </v-list-item>
    </template>
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('help.getting_started')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance"
      :title="t('global.welcome')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/initial-setup"
      :title="t('global.initial_setup')"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('help.installation')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/obtain-domain"
      :title="t('documentation.maintenance.obtain_domain')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/aws-rds-setup"
      :title="t('documentation.maintenance.aws_rds_setup')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/aws-ec2-setup"
      :title="t('documentation.maintenance.aws_ec2_setup')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/application-install"
      :title="t('documentation.maintenance.application_install')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/aws-s3-setup"
      :title="t('documentation.maintenance.aws_s3_setup')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/outbound-email-setup"
      :title="t('documentation.maintenance.outbound_email_setup')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/post-install-configuration"
      :title="t('documentation.maintenance.post_install_configuration')"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('setting.integration')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/google-maps-integration"
      :title="t('documentation.maintenance.google_maps')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/openweathermap-integration"
      :title="t('documentation.maintenance.openweathermap')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/google-authentication-setup"
      :title="t('documentation.maintenance.google_auth_setup')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/google-contacts-integration"
      :title="t('documentation.maintenance.google_contacts')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/google-calendar-integration"
      :title="t('documentation.maintenance.google_calendar')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/google-drive-integration"
      :title="t('documentation.maintenance.google_drive')"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('documentation.maintenance.ongoing')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/updating#"
      :title="t('documentation.maintenance.updating_application')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/update-aws-rds"
      :title="t('documentation.maintenance.update_aws_rds')"
      @click="setRailModeOff"
    />
    <v-list-subheader
      class="text-body-large bg-primary-darken-1 opacity-60"
      color="white"
      :title="t('documentation.maintenance.misc')"
      @click="setRailModeOff"
    />
    <menu-item
      v-if="can('access_system_monitor')"
      to="/docs/admin/maintenance/system-monitor-dashboard#"
      :title="t('maintenance.system_monitor_dashboard')"
      @click="setRailModeOff"
    />
    <menu-item
      to="/docs/maintenance/background-tasks"
      :title="t('documentation.maintenance.background_tasks')"
      @click="setRailModeOff"
    />
  </v-list-group>
  <menu-item
    to="/docs/glossary"
    prepend-icon="fas fa-book"
    :title="t('glossary.title')"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useAuth, useMenu, usePermissions, useSettings } from '@/composables';
import MenuItem from './MenuItem.vue';

const { getSetting } = useSettings();

const { authUser } = useAuth();
const { can, canAny } = usePermissions();
const { setRailModeOff } = useMenu();

const { t } = useI18n();
</script>

<style scoped>
.v-list-item {
  --indent-padding: 8px;
}
.v-list-subheader {
  --indent-padding: 20px;

}
</style>
